import {
  ProductImageBlock,
  ProductImageBlockProps,
  useCaseType,
} from '@rimactechnology/rimac-ui-lib';

import { ProductImageBlockFragment } from '@/api';
import { ORIENTATION_TYPE } from '@/constants/constants';
import getCdlPublicId from '@/hooks/useCdlPublicId';

interface EnhancedProductImageBlockProps {
  productImageBlock?: ProductImageBlockFragment | null;
  orientation?: ORIENTATION_TYPE;
  parentIndex: number;
}

export default function EnhancedProductImageBlock({
  productImageBlock,
  orientation = ORIENTATION_TYPE.IMAGE_LEFT,
  parentIndex = 1,
}: EnhancedProductImageBlockProps) {
  const productImageBlockProps: ProductImageBlockProps = {
    orientation,
    parentIndex: parentIndex,
    title: productImageBlock?.title || '',
    subtitle: productImageBlock?.subtitle || '',
    galleryExtraText: productImageBlock?.galleryExtraText || '',
    extraText: productImageBlock?.extraText || '',
    anchor: productImageBlock?.anchor || undefined,
    paragraphs: [
      productImageBlock?.paragraph || '',
      productImageBlock?.paragraphTwo || '',
    ],
    images: [
      {
        imgSrc:
          getCdlPublicId(
            productImageBlock?.image?.img_desktop.data?.attributes?.url,
          ) || 'rimac/ui-lib/sample',
        imgSrcMobile:
          getCdlPublicId(
            productImageBlock?.image?.img_mobile?.data?.attributes?.url,
          ) || 'rimac/ui-lib/sample',
        alt: productImageBlock?.image?.alt || '',
        blurHash:
          productImageBlock?.image?.img_desktop.data?.attributes?.blurhash ||
          'LAS?DV%M_3D%t7fQofj[~qM{4n-;',
      },
    ],
    button: {
      label: productImageBlock?.button?.label || '',
      path: productImageBlock?.button?.path || '',
      useCase: 'group' as useCaseType,
    },
    largeSpecsTable: (productImageBlock?.largeSpec || []).map((spec) => ({
      label: spec?.label || '',
      value: spec?.value || '',
    })),
  };

  return <ProductImageBlock {...productImageBlockProps} />;
}
